import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiFees from '../../Api/ApiFees';
import ToastMsg from '../../Components/ToastMsg';
import { creators as FeesActions } from '../../Reducers/Reporting/Fees';

export function* getFeesSummary({ payload }) {
  try {
    const response = yield call(
      ApiFees.getSummary,
      payload.selectedYears,
      payload.DateKey,
    );

    if (response.status === 200) {
      yield put(FeesActions.feesSuccess({ summaryData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Fees Summary',
            text: response.message,
          },
        },
      );
      yield put(FeesActions.feesFailure(response.message));
    }
  } catch (e) {
    yield put(FeesActions.feesFailure(e));
  }
}

export function* getFeesDetail({ payload }) {
  try {
    const response = yield call(
      ApiFees.getDetail,
      payload.selectedYears,
      payload.DateKey,
    );

    if (response.status === 200) {
      yield put(FeesActions.feesSuccess({ detailData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Fees Detail',
            text: response.message,
          },
        },
      );
      yield put(FeesActions.feesFailure(response.message));
    }
  } catch (e) {
    yield put(FeesActions.feesFailure(e));
  }
}
